import React, { PureComponent } from "react";
import { Picker, Icon, Loading } from "@ss/mtd-react3";
import "./style.scss";
import { getCollectionDetail } from "@/api/BrandAggregation/collection.js";
import arrowLeft from "@/assets/images/arrow-left.png";
import { fetchData } from "@/utils";
import urls from "@/urls";
import noContent from "@/assets/images/no-content.png";

const data = [
    { label: "Recently Updated", value: "Recently Updated" },
    { label: "Most Downloaded", value: "Most Downloaded" },
    { label: "Most Viewed", value: "Most Viewed" }
];
const formatter = value => {
    return (
        <span>
            <span
                style={{
                    color: "rgba(17, 25, 37, 0.65)",
                    marginRight: "7px"
                }}
            >
                Sort by
            </span>
            {value.value}
        </span>
    );
};
// 添加排序参数映射
const sortMapping = {
    "Recently Updated": "updateTime",
    "Most Downloaded": "downloadNum",
    "Most Viewed": "browseNum"
};
export default class CollectionDetail extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            collectSortValue: "Recently Updated",
            collectionCode: "",
            CollectionDetailData: [],
            pageLoading: false
        };
    }

    componentDidMount() {
        this.searchCollectionDetail();
    }

    componentWillUnmount() {}
    // 添加Collection排序处理方法
    handleCollectSortChange = value => {
        const sortValue = value.value;
        this.setState({ collectSortValue: sortValue });
        // 根据选择的值获取对应的排序字段
        // const sortCol = sortMapping[sortValue];

        // // 调用接口时传入映射后的参数
        // this.setState({ sortCol }, () => {
        //     // 在回调中调用接口，此时能获取到最新的 sortCol
        //     this.searchCollectionData();
        // });
    };
    // 搜索合集数据的方法
    searchCollectionDetail = async (isLoadMore = false) => {
        const { collectionObj } = this.props;
        if (!collectionObj?.collectionCode) {
            console.error("Missing collectionCode");
            return;
        }
        try {
            // 调用接口获取数据
            // const response = await getCollectionDetail({
            //     collectionCode: collectionObj.collectionCode
            //     // 其他参数
            // });
            this.setState({ pageLoading: true });
            const isInner = window.location.href.indexOf('assets-internal') > -1;
            const response = await fetchData(
                isInner ? urls.brandAggregation.collection.getCollectionDetail : urls.brandAggregation.collectionOuter.getCollectionDetail,
                {
                    collectionCode: collectionObj.collectionCode
                }
            );
            // 更新状态
            this.setState(() => ({
                pageLoading: false,
                CollectionDetailData: response.relatedMaterials || []
            }));
        } catch (error) {
            console.error("获取数据失败:", error);
            this.setState({
                CollectionDetailData: [], // 失败时设置为空数组
                pageLoading: false
            });
        }
    };
    // 跳转详情页
    handleToAssetDetail = materialCode => {
        // this.props.history.push(`/AssetDetail?materialCode=${materialCode}`);
        window.open(
            `${window.location.href.indexOf('assets-internal') > -1 ? '/assets-internal' : '/assets'}/brand-guidelines/detail?materialCode=${materialCode}`,
            "_blank"
        );
    };
    render() {
        const {
            CollectionDetailData,
            collectSortValue,
            pageLoading
        } = this.state;
        const { collectionObj, onClose } = this.props;

        return (
            <div>
                <div className="collection-detail-header">
                    <div
                        className="collection-detail-header-return"
                        onClick={onClose}
                    >
                        <img src={arrowLeft} alt="" />
                        <span>{collectionObj?.collectionName || ""}</span>
                        <div className="detail-collection">Collection</div>
                    </div>
                    <div className="collection-detail-ort-dropdown">
                        <Picker
                            options={data}
                            formatter={formatter}
                            value={collectSortValue} // 添加 value 属性
                            onChange={this.handleCollectSortChange}
                        ></Picker>
                    </div>
                </div>
                <div className="collection-detail-card-grid">
                    {CollectionDetailData.map((card, index) => (
                        <div key={index} className="collection-detail-card">
                            <div
                                className="collection-detail-card-img"
                                onClick={() =>
                                    this.handleToAssetDetail(card.materialCode)
                                }
                            >
                                <img
                                    key={index}
                                    src={card?.material_img_url[0]?.fileUrl}
                                    alt=""
                                    className="collection-detail-img-item" // 添加不同的类名以便样式控制
                                />
                            </div>
                            <div className="card-info">
                                <div className="card-info-name">
                                    {card.materialName}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {CollectionDetailData?.length > 0 || (
                    <div>
                        {!pageLoading ? (
                            <img
                                className="empty-state"
                                src={noContent}
                                alt=""
                            />
                        ) : (
                            <Loading
                                style={{
                                    width: "100%"
                                }}
                                className="empty-state"
                                size="large"
                                direction="vertical"
                                message="Loading..."
                            />
                        )}
                    </div>
                )}
            </div>
        );
    }
}
